import {
    Box,
    CardBody,
    Heading,
    HStack,
    Stack,
    StackDivider,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react';
import React from 'react';
import {Assignment} from "../../model/assignment";
import {assignmentTranslateKey} from "../../utils/AssignmentTranslateKey";

interface AssignmentRenderProps {
    assignment: Assignment;
}

const AssignmentRender: React.FC<AssignmentRenderProps> = ({assignment}) => {
    return (
        <CardBody width="100%">
            <Heading p="5" as="h3" size="md" textAlign="start">{assignment.IsMain ? "Główny przydział służbowy" : "Przydział służbowy"}</Heading>
            <Stack divider={<StackDivider />} spacing="4">
                {Object.entries(assignment)
                    .filter(([key, ]) => !['Id', 'IsMain'].includes(key))
                    .filter(([key, value]) => value !== "" && value !== null)
                    .map(([key, value]) => (
                        <Box key={key}>
                            <Heading size="xs" textTransform="uppercase">
                                {assignmentTranslateKey[key]}
                            </Heading>
                            <HStack>
                                {['FunctionStartDate', 'FunctionEndDate'].includes(key) ? (
                                    <Text pt="2" fontSize="sm">{value.toString().split('T')[0]}</Text>
                                ) : (
                                    <Text pt="2" fontSize="sm">{value}</Text>
                                )}
                            </HStack>
                        </Box>
                    ))}
            </Stack>
        </CardBody>
    );
};

interface AssignmentsRenderProps {
    assignments: Assignment[];
}

const AssignmentsRender: React.FC<AssignmentsRenderProps> = ({assignments}) => {
    return (
        <>
            {assignments.map((assignment, index) => (
                <AssignmentRender
                    key={index}
                    assignment={assignment}
                />
            ))}
        </>
    );
};
export default AssignmentsRender;